import React, { useContext } from 'react';
import { useTransition, animated } from 'react-spring';
import { TRANSITION_DECELERATE } from '@nokia-csf-uxr/freeform-design-tokens/tokens/transition';
import { SPEED_SLOW } from '@nokia-csf-uxr/freeform-design-tokens/tokens/speed';
import { getEasing, getDuration, getContext, isAnimationDisabled } from 'common';
import { getOverlayStyle } from 'components/MaskStyle';
import { DialogSheetContext } from './DialogSheet';
import Styled from './styles';

export interface DialogSheetFadeAnimationProps extends React.ComponentPropsWithRef<'div'> {
  /**  Content of the DialogSheetFadeAnimation */
  children: React.ReactNode;
  /** Set `true`, to start the fade animation of DialogSheet. */
  isOpen?: boolean;
  /** set true to show the content of DialogSheet overlay */
  showContent: boolean;
  /** Control animation config here. This uses react-spring transitions config. See https://react-spring.io for more information. */
  animationProps?: any;
  /** If true, disable all motion animation for this component.  This property will override any global disableAnimation setting. */
  disableAnimation?: boolean;
}

const DialogSheetFadeAnimation:React.FC<DialogSheetFadeAnimationProps> = ((props: DialogSheetFadeAnimationProps) => getContext(({ disableAnimation }) => {
  const {
    isOpen,
    showContent,
    children,
    animationProps,
    disableAnimation: propsdisableAnimation,
  } = props;
  const context = useContext(DialogSheetContext);
  const defaultAnimationConfig = {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    config: {
      duration: getDuration(SPEED_SLOW),
      easing: getEasing(TRANSITION_DECELERATE)
    },
    onRest: () => {
      !isOpen && context.updateDialogOpen(false);
    },
    immediate: isAnimationDisabled(propsdisableAnimation, disableAnimation),
  };
  const transitions = useTransition(isOpen, null, animationProps || defaultAnimationConfig);
  return (
    <>{transitions.map(({ item, key, props: styles }) => !!item && (
    <Styled.DialogSheetOverlay key={key} as={animated.div} style={styles} $overlay={getOverlayStyle()}>
      {showContent && children}
    </Styled.DialogSheetOverlay>
    ))}
    </>);
}));

DialogSheetFadeAnimation.defaultProps = {
  isOpen: false,
  animationProps: undefined,
  disableAnimation: undefined,
};

DialogSheetFadeAnimation.displayName = 'DialogSheetAnimation';


export default DialogSheetFadeAnimation;
